import React from "react";
import Section from "../../components/section";
import HomePageUpperSection from "../../components/homePageUpperSection";
import UserWrapper from "../../components/userWrap";
import HomePageIntegrations from "../../components/homePageIntegration";
// import HomePageServices from "../../components/homePageServices";
import "./styles.scss";

export default () => (
  <>
    <UserWrapper
      withoutUser={() => <HomePageUpperSection />}
      withLoading={() => <HomePageUpperSection />}
      withUser={(user) => <HomePageUpperSection user />}
    />
    <HomePageIntegrations />
    {/* <HomePageServices/> */}
    {/* <Section grey about>
      <HomePageIntegrations />
    </Section> */}
  </>
);
